import { useEffect } from "react";
import butters from ".././files/natural_butters.json";
import { addDefaultImg } from '../components/imageUtils';

function Butters() {

  useEffect(() => {
      document.title = "Butters - Deww Botanicals";
    }, []);

  return (
    <>
      {/* // Page Header Start */}
      <div
        className="container-fluid page-header"
        style={{ backgroundImage: `url(../assets/images/butter_banner.jpg)`}}
      >
        <div className="container">
          <h1 className="display-5 mb-3 animated slideInDown">Butters</h1>
          <nav aria-label="breadcrumb animated slideInDown">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <a className="text-body"  Using target="_blank" without rel="noreferrer" href="javascript:void(0);">
                  Home
                </a>
              </li>
              <li className="breadcrumb-item text-dark active" aria-current="page">
                Butters
              </li>
            </ol>
          </nav>
        </div>
      </div>
      {/* // Page Header End */}

      <div className="container-xxl py-4 py-md-5 container-fluid p-0 mb-5 wow fadeIn">
        <div className="container">
          <div className="row g-0 align-items-end">
            <div className="col-12">
              <p>
              Butters are rich, semi-solid fats derived from the nuts, seeds, or kernels of various plants.
Common examples include shea butter, cocoa butter, and mango butter. They are packed with
essential fatty acids, vitamins, and antioxidants, making them highly beneficial for skincare and
culinary applications.
              </p>

              <h3>Advantages of Butters?</h3>
              <ul>
                <li>
                Intense Moisturization : Butters provide deep hydration, helping to soften and smooth dry, rough skin.
                </li>
                <li>
                Nutrient-Rich : They are loaded with essential fatty acids, vitamins (A, E), and antioxidants, promoting skin health and repair.
                </li>
                <li>Skin Protection : Butters form a protective barrier on the skin, shielding it from environmental damage and moisture loss.</li>
                <li>Anti-Inflammatory Properties : They can help soothe irritated skin, reduce inflammation, and promote healing.</li>
                <li>Versatility : Used in a variety of applications, from skincare products to cooking, oﬀering both topical and internal benefits</li>
              </ul>

              <div className="section-header text-start mb-2 mt-5 ">
                <h2 className="mb-2">Range of Butters</h2>
                
              </div>
            </div>
          </div>

          <div className="tab-content">
            <div id="tab-1" className="tab-pane fade show p-0 active">
              <div className="row g-4">
                {butters.map((oil, index) => {
                  return (
                    <div
                      className="col-xl-3 col-lg-3 col-md-6 col-6 "
                      key={index} 
                    >
                      <div className="product-item h-100">
                        <div className="position-relative bg-light overflow-hidden">
                          <img
                            className="img-fluid w-100"
                            src={oil.image}
                            onError={addDefaultImg}
                            alt={oil.name}
                          />
                          {/* <div className="bg-secondary rounded text-white position-absolute start-0 top-0 m-2 py-1 px-3 nBadge">
                            New
                          </div> */}
                        </div>
                        <div className="text-center p-1 p-md-4 mt-1">
                          <a className="d-block h6 mb-1" Using target="_blank" without rel="noreferrer" href="">
                            {oil.name}
                          </a>
                          <p>{oil.description}</p>
                          {/* <span className="text-primary me-1">$19.00</span>
                          <span className="text-body text-decoration-line-through">
                            $29.00
                          </span> */}
                        </div>
                        {/* <div className="d-flex border-top">
                                    <small className="w-100 text-center py-2">
                                    <Link to="/butters" className="text-body"><i className="fa fa-eye text-primary me-2"></i> View detail</Link>
                                    </small>
                                    <small className="w-50 text-center py-2">
                                        <a className="text-body" Using target="_blank" without rel="noreferrer" href=""><i className="fa fa-shopping-bag text-primary me-2"></i>Add to cart</a>
                                    </small>
                                </div> */}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Butters;
